import { firestore } from "@/firebase/web";
import { doc, getDoc } from "firebase/firestore";
import { Post } from "@/types/post";
import { mapDocToPost } from "@/utils/mapDocToPost.web";

export async function fetchPost(postId: string): Promise<Post | null> {
  const docRef = doc(firestore, "posts", postId);
  const docSnap = await getDoc(docRef);
  return docSnap.exists() ? mapDocToPost(docSnap) : null;
}
